import api from './api';

export const revenueApi = {
  forecast: () => api.get('/api/revenue/forecast'),
  outstanding: () => api.get('/api/revenue/outstanding'),
};
